module.exports = __webpack_public_path__ + "img/imwizemann.3dfbe5e7.png";